import { styled, css } from "../../../styled-components";

export const InlinePivotViewStyle = styled.div`
    height: 38px;
    background: ${p => p.theme.picker.backgroundColor};
    padding: 2px;
    border-radius: ${p => p.theme.preferredRoundingRadius}px;

    display: flex;
    justify-content: stretch;
    align-items: stretch;
`;

export const ItemWrapper = styled.div<{ isEmoji?: boolean }>`
    position: relative;

    min-width: 1px;
    width: 1px;

    flex-grow: 1;
    flex-shrink: 1;

    color: ${p => p.theme.fgColorDark};
    background-color: transparent;

    cursor: pointer;

    &.current {
        box-shadow: 0px 4px 13px rgba(0, 0, 0, 0.1);
        color: ${p => p.theme.picker.currentColor};
        background-color: ${p => p.theme.picker.currentBgColor};
        font-weight: 600;
    }

    border-radius: ${p => p.theme.preferredRoundingRadius - 2}px;

    ${p => p.theme.fontStyles.Body4}
    ${p =>
        p.isEmoji &&
        css`
            font-size: 19px;
        `}
    text-align: center;

    display: flex;
    justify-content: center;
    align-items: center;

    & > * {
        padding: 4px;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
    }

    transition: background-color 0.2s, color 0.2s;

    &:not(:last-child):not(.current):not(.prior) {
        ::after {
            content: "";
            position: absolute;
            width: 1px;
            height: 50%;
            top: 25%;
            right: 0;
            background-color: ${p => p.theme.fgColorLight};
            opacity: 0.24;
        }
    }
`;
